import { useState, useRef } from "react";
import { MediaRecorder, register } from 'extendable-media-recorder';
import { connect } from 'extendable-media-recorder-wav-encoder';
import axios from "axios";
import uuid from 'react-native-uuid';
import { useDispatch, useSelector } from 'react-redux'
import { setBnText, setEnText, setEntity, setResult, setSession, resetSession, setChatReply, setChatReplyEn, setCost } from './asrSlice'
import Button from 'react-bootstrap/Button';
import { hideLoader, showLoader } from '../loader/loaderSlice';

const AudioRecorderSTT = () => {
    const dispatch = useDispatch()
    const [language, setLanguage] = useState('bn');
    const [permission, setPermission] = useState(false);
    const mediaRecorder = useRef(null);
    const [recordingStatus, setRecordingStatus] = useState("inactive");
    const [stream, setStream] = useState(null);
    const [audioChunks, setAudioChunks] = useState([]);
    const [audio, setAudio] = useState(null);

    const chatId = useSelector((state) => state.chat.chatId);

    const appToken = useSelector((state) => state.auth.appToken);

    const bnText = useSelector((state) => state.asr.bnText);

    const getMicrophonePermission = async () => {
        if ("MediaRecorder" in window) {
            try {
                await register(await connect());
                const streamData = await navigator.mediaDevices.getUserMedia({
                    audio: true,
                    video: false,
                });
                setPermission(true);
                setStream(streamData);
                console.log("Permission is provided");
            } catch (err) {
                alert(err.message);
            }
        } else {
            alert("The MediaRecorder API is not supported in your browser.");
        }
    };

    const startRecording = async () => {
        dispatch(resetSession());
        setRecordingStatus("recording");
        const media = new MediaRecorder(stream, { mimeType: 'audio/wav' });
        //set the MediaRecorder instance to the mediaRecorder ref
        mediaRecorder.current = media;
        mediaRecorder.current.start();
        let localAudioChunks = [];
        mediaRecorder.current.ondataavailable = (event) => {
            if (typeof event.data === "undefined") return;
            if (event.data.size === 0) return;
            localAudioChunks.push(event.data);
        };
        setAudioChunks(localAudioChunks);
    };

    const stopRecording = async () => {
        setRecordingStatus("inactive");
        mediaRecorder.current.stop();
        mediaRecorder.current.onstop = async () => {
            const audioBlob = new Blob(audioChunks, { type: audioChunks[0].type });
            const audioUrl = window.URL.createObjectURL(audioBlob);
            // fileName should be the session id
            const fileNameText = uuid.v4();
            const fileName = fileNameText + ".wav";
            const audioFile = new File([audioBlob], fileName);

            setAudio(audioUrl);
            setAudioChunks([]);

            uploadAudio(audioFile, fileNameText);

        };
    };

    const uploadAudio = async (audioFile, fileName) => {
        const formData = new FormData();
        formData.append("file", audioFile); 
        formData.append("chatId", chatId);     

        // Add model and language parameters for English
        if (language !== 'bn') {
            formData.append("model", "latest_short");
            formData.append("language", "en-US");
        }

        dispatch(showLoader());   

        const endpoint = language === 'bn' 
            ? `${process.env.REACT_APP_BACKEND_URL}/api/asr-test`
            : `${process.env.REACT_APP_BACKEND_URL}/api/asr-test-sa`;

        axios
            .post(endpoint, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "X-API-KEY": appToken
                },
            })
            .then((response) => {
                // Append new ASR text to existing text
                const newText = bnText ? `${bnText}\n${response.data.asrText}` : response.data.asrText;
                dispatch(setBnText(newText));

                dispatch(hideLoader()); 
                dispatch(setSession(fileName));  
            })
            .catch((error) => {
                console.log(error);
                dispatch(hideLoader());
                dispatch(resetSession()); 
            });
    };

    return (
        <div className='recorder mini-card'>
            <h4>Audio Recorder</h4>
            <main>
                <div className="audio-controls d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        {!permission ? (                        
                            <Button
                                variant="outline-dark" 
                                size="sm" 
                                onClick={getMicrophonePermission}
                                className="me-2"
                            >Get Microphone</Button>
                        ) : null}
                        {permission && recordingStatus === "inactive" ? (
                            <Button
                                variant="outline-dark" 
                                size="sm" 
                                onClick={startRecording}
                                className="me-2"
                            >Start Recording</Button>
                        ) : null}
                        {recordingStatus === "recording" ? (
                            <Button
                                variant="outline-dark" 
                                size="sm" 
                                onClick={stopRecording}
                                className="me-2"
                            >Stop Recording</Button>
                        ) : null}
                    </div>
                    <div className="language-selector">
                        <Button 
                            variant={language === 'bn' ? "dark" : "outline-dark"}
                            size="sm"
                            onClick={() => setLanguage('bn')}
                            className="me-2"
                        >
                            Bangla
                        </Button>
                        <Button 
                            variant={language === 'en' ? "dark" : "outline-dark"}
                            size="sm"
                            onClick={() => setLanguage('en')}
                        >
                            English
                        </Button>
                    </div>
                </div>
                {audio ? (
                    <div className="audio-container">
                        <br />
                        <audio src={audio} controls></audio>                        
                    </div>
                ) : null}
            </main>
        </div>
    );
};


export default AudioRecorderSTT;